module.exports = __webpack_public_path__ + "img/167.d435206c.jpg";